import { CONTENT_ENTRY_STATUS } from "~/types/index.js";

export const STATUS_DRAFT = CONTENT_ENTRY_STATUS.DRAFT;
export const STATUS_PUBLISHED = CONTENT_ENTRY_STATUS.PUBLISHED;
export const STATUS_UNPUBLISHED = CONTENT_ENTRY_STATUS.UNPUBLISHED;
